import React from 'react'
import Wallpapers from './components/wallpapers/wallpapers'

import './App.scss'

function App() {
  
  return (
    <div className="App">
      <Wallpapers/>
    </div>
  );
}

export default App;
